/**
 * Точка входа в приложение
 */

//import './styles.css';
import './styles/variables.css';
import './styles/reset.css';
import './styles/layout.css';
import './styles/map.css';
import './styles/sidebar.css';
import './styles/tables.css';
//import './styles/expeditions.css';
//import './styles/fleet.css';
//import './styles/publications.css';

import { initConfig } from './config';
import { i18n } from './i18n';
import { initUI } from './ui';
import { initMap, map } from './map';
import { initLayers } from './layers';
import { store } from './state'; 
import { labParametersAPI, labsAPI } from './api';

import { getFiltersConfig, loadFilterOptions } from './filters';
import { applyFilters } from './filters';

console.log('🚀 Приложение запускается...');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

async function initApp() {
  console.log('✅ DOM готов');

  try {
    console.log('About to init config');
    initConfig();
  } catch (e) {
    console.error('❌ Ошибка инициализации конфигурации:', e);
    return; // Прерываем запуск, если конфиг не загружен
  }
  
  try {
    await i18n.init();
    console.log('🌍 Язык загружен:', i18n.lang);
  } catch (e) {
    console.error('❌ Ошибка инициализации i18n:', e);
  }

  // Инициализация фильтров
  try {
    const filtersConfig = getFiltersConfig();
    if (filtersConfig.length > 0) {
      console.log('🔧 Инициализация фильтров');
      // Загружаем опции для фильтров без зависимостей (первый уровень)
      for (const filter of filtersConfig) {
        const source = filter.source;
        if (source.type === 'api' && (!source.dependsOn || source.dependsOn.length === 0)) {
          await loadFilterOptions(filter.id);
        }
        const initialValue = filter.type === 'multiselect' ? [] : null;
        store.dispatch({
          type: 'SET_FILTER_VALUE',
          payload: { filterId: filter.id, value: initialValue }
        });
      }
    }
    let lastFilterValues = JSON.stringify(store.getState().filters.values);

    store.subscribe(() => {
      const currentFilterValues = JSON.stringify(store.getState().filters.values);
      if (currentFilterValues !== lastFilterValues) {
        lastFilterValues = currentFilterValues;
        applyFilters();
      }
    });
  } catch (e) {
    console.error('❌ Ошибка загрузки фильтров:', e);
  }

  try {
    store.dispatch({ type: 'SET_PARAMETERS_DICT_LOADING', payload: true });
    const response = await labParametersAPI.list(); // Загружаем все параметры
    store.dispatch({ type: 'SET_PARAMETERS_DICT', payload: response.data });
    console.log(' Справочник параметров загружен:', response.data.length, 'параметров');
  } catch (e) {
    console.error('❌ Ошибка загрузки справочника параметров:', e);
  }

  try {
    store.dispatch({ type: 'SET_LABS_DICT_LOADING', payload: true });
    const response = await labsAPI.list();
    store.dispatch({ type: 'SET_LABS_DICT', payload: response.data });
    console.log(' Справочник лабораторий загружен:', response.data.length, 'лабораторий');
  } catch (e) {
    console.error('❌ Ошибка загрузки справочника лабораторий:', e);
  }
  
  initMap();
  initLayers(map);

  try {
    initUI();
    console.log('✅ UI инициализирован');
  } catch (e) {
    console.error('❌ Ошибка инициализации UI:', e);
  }

  // Принудительное обновление размера карты после инициализации UI и применения стилей
  setTimeout(() => {
    try {
      map.updateSize();
      console.log('🔄 Размер карты обновлён. Текущий центр:', map.getView().getCenter());
    } catch (e) {
      console.error('❌ Ошибка updateSize:', e);
    }
  }, 300); // Небольшая задержка гарантирует, что CSS-переходы шапки/сайдбара не сломают расчет
}

// Обработчик изменения размера окна
let resizeTimeout: number;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = window.setTimeout(() => {
    try {
      map.updateSize();
    } catch (error) {
      console.error('Ошибка при resize:', error);
    }
  }, 250);
});